import removeNotNumberFromString from '@app/libs/inputFormat/removeNotNumberFromString';

export default function getSouthKoreaPhoneNumberWithZero(sourcePhoneNumber: string) {
  const phoneNumber = removeNotNumberFromString(sourcePhoneNumber);
  if (!phoneNumber) {
    return '';
  }
  if (!phoneNumber.startsWith('0')) {
    return `0${phoneNumber}`;
  }
  return phoneNumber;
}
